import { Box, Typography } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import {
	// KOSTEN_ARTEN,
	PLATZHALTER_TEXT,
} from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import { find, forEach } from 'lodash';
import GetRecords from '../../../../../../lib/api/GetRecords';
import { APIS } from '../../../../../../lib/constants/apis';
import NachweisPositionSchema from '../../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsNachweisSchema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { Required } from '../../../../../../lib/validation/ValidationTypes';
import { removeDataKeys, removeNullDeep } from '../../../../../../utils/helper';

const VN_P = VerwendungsNachweisSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const STUNDENLISTE_MAPPING = {
	'Inklusive:Musik': VN_P.Antragsunterlagen_Stundenliste_Inklusive_Musik,
	'Klasse:Kunst': VN_P.Antragsunterlagen_Stundenliste_Klasse_Kunst,
	'Klingende:Kita': VN_P.Antragsunterlagen_Stundenliste_Klingende_Kita,
	'Klasse:Musik': VN_P.Antragsunterlagen_Stundenliste_Klasse_Musik,
	'Kultur:Kita': VN_P.Antragsunterlagen_Stundenliste_Kultur_Kita,
};
const SACHBERICHTE_MAPPING = {
	'Inklusive:Musik': VN_P.Antragsunterlagen_Sachberichte_Inklusive_Musik,
	'Klasse:Kunst': VN_P.Antragsunterlagen_Sachberichte_Klasse_Kunst,
	'Klingende:Kita': VN_P.Antragsunterlagen_Sachberichte_Klingende_Kita,
	'Klasse:Musik': VN_P.Antragsunterlagen_Sachberichte_Klasse_Musik,
	'Kultur:Kita': VN_P.Antragsunterlagen_Sachberichte_Kultur_Kita,
};
const FP_with_Sachkostenliste = 'Klasse:Kunst';

const AnlagenVN: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly, printMode } = useApplication();
	const [selectedFoerderLinen, setSelectedFoerderLinen] = useState<any>(null);
	// const [foerderProgramms, setFoerderProgramms] = useState<any[]>([]);

	useEffect(() => {
		const fetchFoerderProgramme = async () => {
			const res = await GetRecords(APIS.FörderProgramme);
			const foerderProgrammsData: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
			// setFoerderProgramms(foerderProgrammsData);

			const result = getSelectedFoerderLinen(application, foerderProgrammsData);
			setSelectedFoerderLinen(result && typeof result === 'object' ? result : {});
		};
		fetchFoerderProgramme();
	}, [application]);

	return (
		<>
			<ApplicationHeading title='Unterlagen' description={PLATZHALTER_TEXT} />
			{selectedFoerderLinen && Object.keys(selectedFoerderLinen || {}).length > 0 && (
				<Box
					sx={
						printMode ?
							{
								breakInside: 'avoid-page',
								pageBreakInside: 'avoid',
							}
						:	{}
					}
				>
					<Typography variant='h6' sx={{ mt: '2rem' }}>
						Stundenlisten
					</Typography>
					<CreateForm
						formStruc={formStrucStundenlisten(selectedFoerderLinen)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
						printMode={printMode}
					/>
				</Box>
			)}
			{selectedFoerderLinen && Object.keys(selectedFoerderLinen || {}).length > 0 && (
				<Box
					sx={
						printMode ?
							{
								breakInside: 'avoid-page',
								pageBreakInside: 'avoid',
							}
						:	{}
					}
				>
					<Typography variant='h6' sx={{ mt: '2rem' }}>
						Sachberichte
					</Typography>
					<CreateForm
						formStruc={formStrucSachberichte(selectedFoerderLinen)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
						printMode={printMode}
					/>
				</Box>
			)}

			{formStrucSachKostenListe(selectedFoerderLinen) && Object.keys(formStrucSachKostenListe(selectedFoerderLinen) || {}).length > 0 && (
				<Box
					sx={
						printMode ?
							{
								breakInside: 'avoid-page',
								pageBreakInside: 'avoid',
							}
						:	{}
					}
				>
					<Typography variant='h6' sx={{ mt: '2rem' }}>
						Sachkostenliste
					</Typography>
					<CreateForm
						formStruc={formStrucSachKostenListe(selectedFoerderLinen)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
						printMode={printMode}
					/>
				</Box>
			)}
		</>
	);
};

export default AnlagenVN;

const formStrucStundenlisten = (selectedPrograms: any) => {
	let struc: FormStrucItem[] = [];
	Object.entries(selectedPrograms).forEach(([_key, value]) => {
		const mappingKey = value as keyof typeof STUNDENLISTE_MAPPING;
		if (STUNDENLISTE_MAPPING[mappingKey]) {
			struc.push({
				fields: [
					{
						...get(STUNDENLISTE_MAPPING, mappingKey, ''),
						validation: [{ validateFunction: Required }],
					},
				],
				userProps: { columnToDivide: 1 },
			});
		}
	});
	return struc;
};

const formStrucSachberichte = (selectedPrograms: any) => {
	let struc: FormStrucItem[] = [];
	Object.entries(selectedPrograms).forEach(([_key, value]) => {
		const mappingKey = value as keyof typeof SACHBERICHTE_MAPPING;
		if (SACHBERICHTE_MAPPING[mappingKey]) {
			struc.push({
				fields: [
					{
						...get(SACHBERICHTE_MAPPING, mappingKey, ''),
						validation: [{ validateFunction: Required }],
					},
				],
				userProps: { columnToDivide: 1 },
			});
		}
	});
	return struc;
};
const formStrucSachKostenListe = (selectedPrograms: any) => {
	let struc: FormStrucItem[] = [];
	forEach(selectedPrograms, (_value: any, _key: any) => {
		if (_value === FP_with_Sachkostenliste) {
			struc.push({
				fields: [
					{
						...VN_P.Antragsunterlagen_Sachkostenliste_Kunst,
					},
				],
				userProps: { columnToDivide: 1 },
			});
		}
	});
	return struc;
};

export const getFormStrucAnlagenVN = (application: any, allFoerderProgramms: any) => {
	const selectedFoerderLinen = getSelectedFoerderLinen(application, allFoerderProgramms);
	return concat(
		formStrucSachberichte(selectedFoerderLinen),
		formStrucStundenlisten(selectedFoerderLinen),
		formStrucSachKostenListe(selectedFoerderLinen),
	);
};

const getSelectedFoerderLinen = (application: any, foerderProgramms: any) => {
	const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);
	const foerderlinenPersonalKosten =
		allKostenPositions.reduce((acc: any, item: any) => {
			const key =
				get(item, NP_P.Foerderprogramm.path, '').id ? get(item, NP_P.Foerderprogramm.path, '').id : get(item, NP_P.Foerderprogramm.path, '');
			if (!acc[key]) {
				const FP = find(foerderProgramms, (item: any) => item.id === key);
				acc[key] = get(FP, 'attributes.Allgemein_Titel', '');
			}
			return acc;
		}, {}) || {};
	return foerderlinenPersonalKosten;
};
